import { render, staticRenderFns } from "./CardEdit.vue?vue&type=template&id=f005ef00&scoped=true"
import script from "./CardEdit.vue?vue&type=script&lang=js"
export * from "./CardEdit.vue?vue&type=script&lang=js"
import style0 from "./CardEdit.vue?vue&type=style&index=0&id=f005ef00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f005ef00",
  null
  
)

export default component.exports